import './js/eventsmanager.js';
import './js/pollyfill.js';
import "scroll-behavior-polyfill";
import modalIsi from './js/modal-isi.js';
import modalExit from './js/modal-exit-init.js';
import modalVideo from './js/modal-video-init.js';
import modalDisclaimer from './js/modal-scrollable-validation.js';
import modalEmailMe from './js/modal-email-me.js';
import modalLabel from './js/modal-label-init.js';
import initializeHeader from './js/header.js';

import isi from './js/isi.js';
import backToTop from './js/back-to-top.js';
import nav from './js/navigation.js';
import lazyload from './js/lazyload-init.js';
import walkingAnimation from './js/walking-animation.js';
import vimeoPlayer from './js/vimeo-player.js';

//Handles all the fatp functionalities
import validateSignUpForm from './js/form-signup.js';
import fatpSearch from './js/fatp-search.js';
import fatpResult from './js/fatp-result.js';
import validateEmailMeForm from './js/form-emailme.js';
import validateUnsubForm from './js/form-unsub.js';
import takeMeThere from './js/take-me-there.js';
import scrollToElement from './js/scroll-to-element.js';

//handles focus state on input - hide sticky
import hideStickyISI from './js/form-input.js';

import ss from './js/ss.js';

//handles accessible video player
import strings from './js/strings.js';
import initPxVideo from './js/px-video.js';

//checks text zoom level
import zoomCheck from './js/zoom-check.js';

const accordion = require("@klickinc/klick-component-accordion-accessible");
window.accordion = accordion; // Make object available for screenshots.
import './js/accordion.hooks.js';

initializeHeader();
isi();
nav();
lazyload();
strings();
initPxVideo();
zoomCheck();
vimeoPlayer();
backToTop();
// console.log("modalDisclaimer", modalDisclaimer)

modalDisclaimer.init();
modalExit();
modalVideo();
modalIsi();
fatpSearch(); //This should be on all pages
takeMeThere();
hideStickyISI();

const is_root =/^\/(index.html)?$/i.test(location.pathname);

//only for home page
if(is_root) {
  walkingAnimation();
  modalLabel.init();
}

if (window.location.href.indexOf('/sign-up') > -1 && window.location.href.indexOf('/sign-up-') < 0 ){
  validateSignUpForm(); //This should only be initialized on sign up page
}
if (window.location.href.indexOf('/provider/results') > -1 ){
  const FindTreatmentProviderResult = fatpResult(); //This should only be initialized on fatp result page
  validateEmailMeForm(FindTreatmentProviderResult);
  modalEmailMe();
}
if (window.location.href.indexOf('/unsubscribe') > -1 && window.location.href.indexOf('/unsubscribe-') < 0 ){
  validateUnsubForm(); //This should only be initialized on unsubscribe page
}

if(window.location.href.indexOf('/resources') > -1) {
  window.addEventListener('pageshow', () =>  {
  scrollToElement();
  });
}

ss();

if (module.hot) {
  module.hot.accept();
}
